<div class="grid grid-cols-2 h-full w-full mobile:flex">

    <div class="bg-primary-800 flex justify-center pt-[15%] mobile:hidden">

        <img src="assets/images/signup-page/dashboard-example.png" alt="{{ 'auth.dashboard_example_image' | transloco }}"
            class="absolute bottom-[5%] left-[40%] transform -translate-x-1/2 opacity-100 w-[70%] h-[70%] pointer-events-none select-none" />


    </div>

    <div class="bg-white p-4 z-50 px-20 flex flex-col justify-between h-screen mobile:px-7 mobile:w-screen">
        <div class="flex justify-start mobile:justify-center mobile:mt-10">
            <app-logo class="self-start"></app-logo>
        </div>

        <div class="flex flex-col justify-center items-center flex-grow">
            <div class="rounded-lg border border-border bg-white py-12 px-[10%] text-center mobile:p-2">
                <h1 class="text-4xl font-bold self-start mobile:text-xl">{{ 'auth.check_email_page.check_your_email' |
                    transloco }}
                </h1>
                <p class="mt-4 self-start text-neutral-800 mobile:text-sm">{{ 'auth.check_email_page.temp_password_sent'
                    |
                    transloco }}</p>
                <p class="mt-1 self-start text-primary mobile:text-sm">{{ userEmail | trimEmail }}</p>
                <p class="mt-6 self-start text-neutral-800 mobile:text-sm">{{
                    'auth.check_email_page.did_not_recieve_temp' |
                    transloco }} <a [routerLink]="'/auth/signup'" [queryParams]="{ email: userEmail | trimEmail }" class="text-primary hover:underline">{{
                        'auth.check_email_page.resend_password' |
                        transloco }}</a></p>

                <div class="max-w-screen-sm w-full mt-8 px-4">
                    <app-primary-button buttonText="{{ 'auth.check_email_page.sign_up_with_temporary_password' | transloco }}"
                        [isDisabled]="false" (buttonClick)="signUpPage()"></app-primary-button>
                </div>
            </div>
            <div class="mt-[10%] max-w-screen-sm text-center">
                <app-terms-and-conditions></app-terms-and-conditions>
            </div>
        </div>
        <p class="text-sm text-neutral-800 text-center mb-[2%] mobile:text-xs">{{
            'shared.all_rights_reserved' | transloco }}</p>
    </div>


</div>